import { render } from "./HeadstoneItem.vue?vue&type=template&id=5226bcbf&scoped=true&ts=true"
import script from "./HeadstoneItem.vue?vue&type=script&lang=ts"
export * from "./HeadstoneItem.vue?vue&type=script&lang=ts"

import "./HeadstoneItem.vue?vue&type=style&index=0&id=5226bcbf&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5226bcbf"]])

export default __exports__